module.exports = __webpack_public_path__ + "static/media/melanye-finister.b0e54efc.md";